import fetch from '@api/fetchers';

export interface QuotaDetailsResponse {
  quotaDetails?: Record<string, unknown>;
  userPlatformPlan?: number;
}

export default function fetchQuotaDetails(
  goalUID: string
): Promise<QuotaDetailsResponse> {
  return fetch('v1/common/quota/details/', {
    params: { goal_uid: goalUID }
  });
}
